<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { onBeforeMount, ref } from 'vue'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollStore } from '@/store/payroll-data'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { notificationError } from '@/app/core/util/notificationUtils'
import { getSelectData } from '@/app/core/services/get-table'
import { useI18n } from 'vue-i18n'
import { DLoading } from 'front-library'
import { getLoan, createLoan, updateLoan } from '../../../core/services/loans'
usePayrollChange(() =>
  Boolean(route.params.id) ? back() : window.location.reload()
)

/* payload, router, notifications */
const storePayroll = usePayrollStore()
const notifications = useNotificationsStore()
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)
const messageLoading = ref('')

/* Datos */
const customForm = ref<any>({})
let model: any = {}

const onSubmit = async (model: any) => {
  loading.value = true
  let saved = false
  try {
    if (!route.params.id) {
      saved = await createLoan(model)
    } else {
      saved = await updateLoan(model, `${route.params.id as string}`)
    }
    if (saved) {
      loading.value = false
      notifications.addNotification({
        title: !route.params.id
          ? t('notification.created')
          : t('notification.edited'),
        text: t('loans.notification.action', [
          !route.params.id
            ? t('notification.wasCreated')
            : t('notification.wasEdited')
        ]),
        type: 'success',
        time: 10000
      })
      void router.push({ name: 'ListLoans' })
    }
  } catch (error: any) {
    notificationError(error, 'loans', t, notifications, loading)
  }
}

const getEntity = async () => {
  if (!route.params.id) return
  model = await getLoan(route.params.id as string)
  if (model === undefined) {
    notifications.addNotification({
      title: t('notification.notFound'),
      text: t('loans.notification.error'),
      type: 'error',
      time: 10000
    })
    back()
  }
}

const onUpdateField = async (field: any) => {
  if (
    field.name === 'typeLoansId' &&
    storePayroll.payroll?.country.iso_code === 'MX'
  ) {
    loading.value = true
    const data = customForm.value.tabs.flatMap((tab: { groups: any[] }) =>
      tab.groups.flatMap(
        (group: { fields: any[] }) =>
          group.fields.find((input: { name: any }) => input.name === field.name)
            ?.query
      )
    )[0]
    const selectData: any[] = await getSelectData(data)
    const codeLoanType = selectData.find(
      (item: { id: any }) => item.id === field.value
    )?.code
    customForm.value.tabs.forEach((tab: { groups: any[] }) =>
      tab.groups.forEach((group: { fields: any[] }) =>
        group.fields.forEach((input: { name: string; label: string }) => {
          if (input.name === 'quotaAmount') {
            switch (codeLoanType) {
              case 'INFONAVIT-SM':
                input.label = t('loans.fields.infonavitSM.label')
                break
              case 'INFONAVIT-CF':
                input.label = t('loans.fields.infonavitCF.label')
                break
              case 'INFONAVIT-PF':
                input.label = t('loans.fields.infonavitPF.label')
                break
            }
          }
        })
      )
    )
    loading.value = false
  }
}

/* Volver */
const back = () => {
  void router.push({ name: 'ListLoans' })
}

onBeforeMount(async () => {
  loading.value = true
  try {
    await getEntity()
    customForm.value = await getForm({ entity: 'loans' })
    if (route.params.id !== undefined) {
      messageLoading.value = t('loading.data')
      onUpdateField({ name: 'typeLoansId', value: model.typeLoansId })
    }
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('loans.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      notificationError(error, 'loans', t, notifications, loading)
    }
  }
})
</script>
<template>
  <DLoading v-show="loading" :message="messageLoading" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="
            route.params.id == undefined ? t('loans.create') : t('loans.edit')
          " />
      </div>
    </div>
    <DynamicForm
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :title-btn-save="
        route.params.id === undefined
          ? t('form.button.save')
          : t('form.button.update')
      "
      @cancel="back"
      @submit="onSubmit"
      @update-field="onUpdateField" />
  </div>
</template>
